import React from "react";
import Card from "../components/Card.js";
import Bankist from "../resource/bankist.png";
import Mapty from "../resource/mapty.png";
import Forkify from "../resource/forkify.png";
import Name from "../components/Name.js";

function ProjectsPage(props) {
  return (
    <div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <Card
          styles={{
            backgroundImage: `url(${Bankist})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "500px",
            height: "220px",
            marginLeft: "50px",
            marginTop: "30px",
            border: "2px solid #808080",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
          }}
        />
        <Card
          styles={{
            backgroundImage: `url(${Mapty})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "500px",
            height: "220px",
            marginLeft: "220px",
            marginTop: "30px",
            border: "2px solid #808080",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Card
          styles={{
            backgroundImage: `url(${Forkify})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "445px",
            height: "264px",
            marginLeft: "50px",
            marginTop: "120px",
            border: "2px solid #808080",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
          }}
        />
        <Name
          text={"Bankist"}
          styles={{
            position: "absolute",
            left: "230px",
            top: "250px",
            backgroundImage: "linear-gradient(to right, #ff3366, #33ccff)", // Define the gradient
            WebkitBackgroundClip: "text", // For Safari
            color: "transparent", // Make the text transparent
            fontSize: "30px",
            fontFamily: "Rubik, sans-serif",
          }}
        />
        <Name
          text={": fictional digital bank with various functionalities"}
          styles={{
            color: "black",
            position: "absolute",
            left: "343px",
            top: "257px",
            fontSize: "20px",
            fontFamily: "Rubik, sans-serif",
          }}
        />
        <a
          href="https://bankist-czh.netlify.app/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            fontSize: "17px",
            color: "grey",
            marginLeft: "20px",
            position: "absolute",
            top: "306px",
            left: "665px",
          }}
        >
          Find out more
          <span
            style={{
              content: '""',
              position: "absolute",
              right: "0.5px",
              width: "100%",
              height: "3px", // Adjust the thickness of the underline
              bottom: "-2px", // Adjust the distance of the underline from the text
              backgroundImage: "linear-gradient(90deg, #3498db, #ff3366)", // Gradient for curly effect
              backgroundSize: "200% 2px", // Adjust the size of the gradient
              transition: "background-position 0.3s ease",
            }}
          />
        </a>
        <Name
          text={"Mapty"}
          styles={{
            position: "absolute",
            right: "500px",
            top: "250px",
            backgroundImage: "linear-gradient(to right, #00ff00, #33cc33)", // Greenish gradient
            WebkitBackgroundClip: "text", // For Safari
            color: "transparent", // Make the text transparent
            fontSize: "30px",
            fontFamily: "Rubik, sans-serif",
          }}
        />
        <Name
          text={": web application for storing workout information"}
          styles={{
            color: "black",
            position: "absolute",
            right: "40px",
            top: "257px",
            fontSize: "20px",
            fontFamily: "Rubik, sans-serif",
          }}
        />
        <a
          href="https://mapty-by-czh.netlify.app/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            fontSize: "17px",
            color: "grey",
            marginLeft: "20px",
            position: "absolute",
            top: "306px",
            right: "40px",
          }}
        >
          Find out more
          <span
            style={{
              content: '""',
              position: "absolute",
              right: "0.5px",
              width: "100%",
              height: "3px", // Adjust the thickness of the underline
              bottom: "-2px", // Adjust the distance of the underline from the text
              backgroundImage: "linear-gradient(90deg, #3498db, #ff3366)", // Gradient for curly effect
              backgroundSize: "200% 2px", // Adjust the size of the gradient
              transition: "background-position 0.3s ease",
            }}
          />
        </a>
        <Name
          text={"Forkify"}
          styles={{
            position: "absolute",
            right: "850px",
            bottom: "50px",
            backgroundImage: "linear-gradient(to right, #ff8c00, #ffcc66)", // Greenish gradient
            WebkitBackgroundClip: "text", // For Safari
            color: "transparent", // Make the text transparent
            fontSize: "30px",
            fontFamily: "Rubik, sans-serif",
          }}
        />
        <Name
          text={": web application for searching for recipes"}
          styles={{
            color: "black",
            position: "absolute",
            right: "450px",
            bottom: "54px",
            fontSize: "20px",
            fontFamily: "Rubik, sans-serif",
          }}
        />
        <a
          href="https://forkify-zhmaster.netlify.app/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            fontSize: "17px",
            color: "grey",
            marginLeft: "20px",
            position: "absolute",
            bottom: "25px",
            right: "450px",
          }}
        >
          Find out more
          <span
            style={{
              content: '""',
              position: "absolute",
              right: "0.5px",
              width: "100%",
              height: "3px", // Adjust the thickness of the underline
              bottom: "-2px", // Adjust the distance of the underline from the text
              backgroundImage: "linear-gradient(90deg, #3498db, #ff3366)", // Gradient for curly effect
              backgroundSize: "200% 2px", // Adjust the size of the gradient
              transition: "background-position 0.3s ease",
            }}
          />
        </a>
      </div>
    </div>
  );
}
export default ProjectsPage;
